import { createTypes, async } from 'redux-action-creator';

export const types: { [key: string]: string } = createTypes([
  ...async('CHANGE'),
  'RESET',
], 'WORK_ITEM_UPDATE_STATUS');
